module.exports = __webpack_public_path__ + "static/img/luther-univ.413afdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/luther-univ.jpg
// module id = qewO
// module chunks = 0